import React from 'react';
import DropDownMenu from 'material-ui/DropDownMenu';
import RaisedButton from 'material-ui/RaisedButton';
import ActionSearch from 'material-ui/svg-icons/action/search';
import ActionAutoRenew from 'material-ui/svg-icons/action/autorenew';
import MenuItem from 'material-ui/MenuItem';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import '../Search.css';
import {green400} from 'material-ui/styles/colors';
import {lfGreen, lfTan} from './lfColors.js';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

const WITHIN_5_MILES      = 0;
const WITHIN_10_MILES     = 1;
const WITHIN_20_MILES     = 2;
const WITHIN_50_MILES     = 3;
const WITHIN_100_MILES    = 4;
const WITHIN_ANY_MILES    = 5;

const muiTheme = getMuiTheme({
  palette: {
    primary1Color: lfGreen[300],
    accent1Color: lfGreen[400],
    pickerHeaderColor: green400,
    color:lfTan[100],
  },
  menuItem: {
    selectedTextColor: green400,
  },
});



export default class SearchForm extends React.Component {
  
  state = {
    dist:WITHIN_5_MILES,   // This is the drop down item postion
    isLost:true,
    useCurrentLocation:true,
    lfType:0,
  
  };

  getSearchRadiusMiles = ( dropDownPos ) => {

    var searchRadiusMiles = 100.0;
    switch( dropDownPos ){
      default : // 100 miles
          searchRadiusMiles = 100.0;
          break;
      case WITHIN_5_MILES :
          searchRadiusMiles = 5.0;
          break;
      case WITHIN_10_MILES :
          searchRadiusMiles = 10.0;
          break;
      case WITHIN_20_MILES :
          searchRadiusMiles = 20.0;
          break;
      case WITHIN_50_MILES :
          searchRadiusMiles = 50.0;
          break;
      case WITHIN_100_MILES :
          searchRadiusMiles = 100.0;
          break;
      case WITHIN_ANY_MILES :
          searchRadiusMiles = 10000.0;
          break;
    }

    return searchRadiusMiles;

  }
  

  handleSearch = () => {

    let status = 1;
    if( !this.state.isLost ){
      status = 2;
    }
    let searchRadiusMiles = this.getSearchRadiusMiles( this.state.dist );
    this.props.handleSearch(this.state.useCurrentLocation, 
      status,
      this.state.lfType,
      searchRadiusMiles
    );
  };

  handleClearSearch = () => {
    this.props.handleClearSearch();
  };



handleTypeMenuChange = (event, key, value) => {
    // id is not gettig set in the DropDownMenu, so there are separate handlers 
    // for each drop down menu.
 
    this.setState({
      lfType: value,
    });
    
}

  handleDistMenuChange = (event, key, value) => {
      this.setState({
        dist:value,
      });

       
  }


  handleRadioButtonClick = (event ) => {
    if (event.target.id === 'rbIsLost') {
      this.setState({
        isLost: true,
      });
    } 
    else if (event.target.id === 'rbIsFound') {
      this.setState({
        isLost: false,
      });
    } 
    else if (event.target.id === 'rbUseCurrentLocation') {
      this.setState({
        useCurrentLocation:true,
      });
    } 
    else if (event.target.id === 'rbWillClickOnMap') {
      this.setState({
        useCurrentLocation:false,
      });
    } 
  }


  render() {


    const typeMenuItems = [];
    typeMenuItems.push( <MenuItem value={0} key={0} primaryText={`Dogs`} />);
    typeMenuItems.push( <MenuItem value={1} key={1} primaryText={`Cats`} />);
    typeMenuItems.push( <MenuItem value={2} key={2} primaryText={`Birds`} />);
    typeMenuItems.push( <MenuItem value={3} key={3} primaryText={`Reptiles`} />);
    typeMenuItems.push( <MenuItem value={4} key={4} primaryText={`Other`} />);
  

    const distMenuItems = [];
    distMenuItems.push( <MenuItem value={WITHIN_5_MILES} key={WITHIN_5_MILES} primaryText={`5 miles`} />);
    distMenuItems.push( <MenuItem value={WITHIN_10_MILES} key={WITHIN_10_MILES} primaryText={`10 miles`} />);
    distMenuItems.push( <MenuItem value={WITHIN_20_MILES} key={WITHIN_20_MILES} primaryText={`20 miles`} />);
    distMenuItems.push( <MenuItem value={WITHIN_50_MILES} key={WITHIN_50_MILES} primaryText={`50 miles`} />);
    distMenuItems.push( <MenuItem value={WITHIN_100_MILES} key={WITHIN_100_MILES} primaryText={`100 miles`} />);
    distMenuItems.push( <MenuItem value={WITHIN_ANY_MILES} key={WITHIN_ANY_MILES} primaryText={`Any miles`} />);
    

    /* Location selection radio buttons */
    const locationRadioButtons = [];
    locationRadioButtons.push( <RadioButton 
      id="rbUseCurrentLocation" key={0} value={0} 
      onClick={this.handleRadioButtonClick}
      label={`of my device's current location`}
      className="locationRadioButtonTop" />      
    );
    locationRadioButtons.push( <RadioButton 
      id="rbWillClickOnMap" key={1} value={1}
      onClick={this.handleRadioButtonClick}
      label={`I will click on the map.`}
      className="locationRadioButtonBottom"
      />      
    );


    const statusRadioButtons = [];
    statusRadioButtons.push( <RadioButton  
      id="rbIsLost" key={1} value={1}
      onClick={this.handleRadioButtonClick}
      label={`lost`}
      labelStyle={{color: 'red'}}
      className="statusRadioButtonLost" />      
    );
    statusRadioButtons.push( <RadioButton 
        id="rbIsFound" key={2} value={2}
        onClick={this.handleRadioButtonClick}
        label={`found`}
        labelStyle={{color: 'blue'}}
        className="statusRadioButtonFound" />      
    );

    return(
      <div className="searchWrapper">

        <div className="contentContainer">

          <div className="title">Search</div>
          <div className="findAllLabel">Find all</div>
          <MuiThemeProvider muiTheme={muiTheme}>
            <DropDownMenu 
              id="type"
              className="typeDropdown"
              maxHeight={100}             
              autoWidth={false} 
              value={this.state.lfType}
              onChange={this.handleTypeMenuChange}>
              {typeMenuItems}
            </DropDownMenu>
          </MuiThemeProvider>
          
          <div className="thatAreLabel">that are</div>

          <MuiThemeProvider muiTheme={muiTheme} >
            <RadioButtonGroup name="status" defaultSelected={1}>
              {statusRadioButtons}
            </RadioButtonGroup>
          </MuiThemeProvider>

          <div className="withinLabel">within</div>

          <MuiThemeProvider muiTheme={muiTheme}>
            <DropDownMenu 
              id="dist"
              className="distDropdown"
              maxHeight={100} 
              autoWidth={false} 
              value={this.state.dist}
              onChange={this.handleDistMenuChange}>
              {distMenuItems}
            </DropDownMenu>
          </MuiThemeProvider>

          <MuiThemeProvider muiTheme={muiTheme}>
            <RadioButtonGroup name="location" defaultSelected={0} >
              {locationRadioButtons}
            </RadioButtonGroup>
          </MuiThemeProvider>

          <div className="iWillClickOnMapInst">Click the search button first, then click on the map.</div>

        </div>

 
        <div className="searchButtonWrapper"> 



          <MuiThemeProvider muiTheme={muiTheme}>
            <RaisedButton
              className="searchButton"
              icon={<ActionSearch />}
              label="Search"
              primary={true}
              onClick={this.handleSearch}            
            />
          </MuiThemeProvider>

          <MuiThemeProvider muiTheme={muiTheme}>
            <RaisedButton
              className="clearSearchButton"
              icon={<ActionAutoRenew />}
              label="Reload"
              primary={true}
              onClick={this.handleClearSearch}           
            />
          </MuiThemeProvider>
        </div>


      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Components/SearchForm.js